import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import SidebarElement from '@/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue';
import { Props, SlotNames, NamePositions } from './types';

@Component({
  components: { SidebarElement },
})
export default class ComponentPageOrganization extends Vue implements Props {
  // Props
  @Prop({ type: String, default: '' })
  address: string;

  @Prop({ type: String, default: 'Адрес' })
  addressTitle: string;

  @Prop({ type: Object, default: {} })
  careerCenter: object;

  @Prop({ type: String, default: 'Все программы организации' })
  allProgramsTitle: string;

  @Prop({ type: String, default: 'Все вакансии организации' })
  allVacanciesTitle: string;

  @Prop({ type: Boolean, default: false })
  borderTop: boolean;

  @Prop({ type: String, default: 'Контакты организации' })
  contactsTitle: string;

  @Prop({ type: String, default: '' })
  email: string;

  @Prop({ type: String, default: '' })
  logo: string;

  @Prop({ type: String, default: '' })
  municipality: string;

  @Prop({ type: String, default: 'Муниципалитет' })
  municipalityTitle: string;

  @Prop({ type: String, default: '' })
  cop_multi_name: string;

  @Prop({ type: String, default: '' })
  cop_multi: string;

  @Prop({ type: [String, Object], default: null })
  municipalityLink: RawLocation;

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ type: String, default: NamePositions.INSIDE })
  namePosition: NamePositions;

  @Prop({ type: String, default: '' })
  phone?: string;

  @Prop({ type: [String, Object], default: '' })
  programsLink: RawLocation;

  @Prop({ type: [String, Object], default: '' })
  vacanciesLink: RawLocation;

  @Prop({ type: Boolean, default: false })
  wideSidebar: boolean;

  // Readonly
  readonly slotNames = SlotNames;
  readonly namePositions = NamePositions;

  // Computed
  get classesTop() {
    return { 'component-page-organization__top_border': this.borderTop };
  }

  get copMultiName() {
    return (
      this.$store.state.copMultiDict.find((el: any) => el.id === this.cop_multi)
        ?.name || this.cop_multi
    );
  }

  get isCareerCenterNotAllNull() {
    return Object.values(this.careerCenter).some((v) => v);
  }

  get isActiveModuleVacancies() {
    return (
      this.$store.getters.hasApiModuleVacancies ||
      this.$store.getters.hasApiModuleVacanciesOrders
    );
  }

  get contacts() {
    const { email, phone } = this;
    return [
      {
        code: 'email',
        href: `mailto:${email}`,
        text: email,
      },
      {
        code: 'phone',
        href: `tel:${phone}`,
        text: phone,
      },
    ].filter(({ text }) => !!text);
  }

  get mainClasses() {
    return { 'component-page-organization__main_swaged': this.wideSidebar };
  }

  get sidebarClasses() {
    return {
      'component-page-organization__sidebar_extended': this.wideSidebar,
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/page/organization/script.ts